import React from 'react';

import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFingerprint } from '@fortawesome/free-solid-svg-icons';

const DocumentoRelacionado = ({ documentos = [] }) => {
    // Si no es arreglo (por código viejo), lo convertimos a arreglo
    const docs = Array.isArray(documentos) ? documentos : (documentos && Object.keys(documentos).length > 0 ? [documentos] : []);

    if (docs.length === 0) return null;

    return (
        <div className="mb-4">
            <h6 className="fw-bold mb-3 border-bottom pb-2">DOCUMENTOS RELACIONADOS (PAGADOS)</h6>
            
            {docs.map((doc, idx) => (
                <div key={idx} className="p-3 border rounded bg-light mb-3" style={{ transition: 'all 0.2s ease' }}>
                    <div className="mb-2">
                        <span className="text-secondary fw-bold" style={{ fontSize: '0.8rem' }}>
                            <FontAwesomeIcon icon={faFingerprint} className="me-1 text-muted" />UUID: 
                        </span>
                        <span className="font-monospace text-dark ms-1" style={{ fontSize: '0.9rem' }}>
                            {doc?.idDocumentoRelacionado}
                        </span>
                    </div>

                    <div className="mb-2 d-flex flex-wrap gap-2 align-items-center">
                        <div>
                            <span className="text-muted" style={{ fontSize: '0.85rem' }}>Serie y Folio: </span>
                            <span className="text-dark fw-bold" style={{ fontSize: '0.85rem' }}>{doc?.serie} {doc?.folio}</span>
                        </div>
                        <span className="text-muted">|</span>
                        <div>
                            <span className="text-muted" style={{ fontSize: '0.85rem' }}>Parcialidad: </span>
                            <span className="text-dark fw-bold" style={{ fontSize: '0.85rem' }}>{doc?.numParcialidad}</span>
                        </div>
                        <span className="text-muted">|</span>
                        <div>
                            <span className="text-muted" style={{ fontSize: '0.85rem' }}>Moneda: </span>
                            <span className="text-dark fw-bold" style={{ fontSize: '0.85rem' }}>{doc?.monedaDocumentoRelacionado}</span>
                        </div>
                        <span className="text-muted">|</span>
                        <div>
                            <span className="text-muted" style={{ fontSize: '0.85rem' }}>Equivalencia DR: </span>
                            <span className="text-dark fw-bold" style={{ fontSize: '0.85rem' }}>{doc?.equivalenciaDR || '1'}</span>
                        </div>
                        <span className="text-muted">|</span>
                        <div>
                            <span className="text-muted" style={{ fontSize: '0.85rem' }}>Objeto Impuesto DR: </span>
                            <span className="text-dark fw-bold" style={{ fontSize: '0.85rem' }}>{doc?.objetoImpDR}</span>
                        </div>
                    </div>
                    
                    <div className="pt-2 border-top d-flex flex-wrap gap-3 mt-2">
                        <div>
                            <span className="text-muted" style={{ fontSize: '0.85rem' }}>Saldo Anterior: </span>
                            <span className="text-dark fw-bold" style={{ fontSize: '0.85rem' }}>${doc?.importeSaldoAnterior}</span>
                        </div>
                        <span className="text-muted">|</span>
                        <div>
                            <span className="text-muted" style={{ fontSize: '0.85rem' }}>Importe Pagado: </span>
                            <span className="text-success fw-bold" style={{ fontSize: '0.85rem' }}>${doc?.importePagado}</span>
                        </div>
                        <span className="text-muted">|</span>
                        <div>
                            <span className="text-muted" style={{ fontSize: '0.85rem' }}>Saldo Insoluto: </span>
                            <span className="text-danger fw-bold" style={{ fontSize: '0.85rem' }}>${doc?.importeSaldoInsoluto}</span>
                        </div>
                    </div>

                    {/* Impuestos DR (Traslados) */}
                    {doc?.impuestosDR && doc.impuestosDR.length > 0 && (
                        <div className="mt-3 pt-2 border-top">
                            <span className="text-muted fw-bold d-block mb-1" style={{ fontSize: '0.8rem' }}>IMPUESTOS DEL DR (TRASLADOS):</span>
                            {doc.impuestosDR.map((imp, iIdx) => (
                                <div key={`t-${iIdx}`} className="d-flex flex-wrap gap-3" style={{ fontSize: '0.85rem' }}>
                                    <div><span className="text-muted">Impuesto:</span> <span className="fw-bold">{imp.ImpuestoDR}</span></div>
                                    <span className="text-muted">|</span>
                                    <div><span className="text-muted">Base:</span> <span className="fw-bold">${imp.BaseDR}</span></div>
                                    <span className="text-muted">|</span>
                                    <div><span className="text-muted">Tipo Factor:</span> <span className="fw-bold">{imp.TipoFactorDR}</span></div>
                                    <span className="text-muted">|</span>
                                    <div><span className="text-muted">Tasa/Cuota:</span> <span className="fw-bold">{imp.TasaOCuotaDR}</span></div>
                                    <span className="text-muted">|</span>
                                    <div><span className="text-muted">Importe:</span> <span className="fw-bold text-dark">${imp.ImporteDR}</span></div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Impuestos DR (Retenciones) */}
                    {doc?.retencionesDR && doc.retencionesDR.length > 0 && (
                        <div className="mt-2 pt-2 border-top">
                            <span className="text-muted fw-bold d-block mb-1" style={{ fontSize: '0.8rem' }}>IMPUESTOS DEL DR (RETENCIONES):</span>
                            {doc.retencionesDR.map((ret, rIdx) => (
                                <div key={`r-${rIdx}`} className="d-flex flex-wrap gap-3" style={{ fontSize: '0.85rem' }}>
                                    <div><span className="text-muted">Impuesto:</span> <span className="fw-bold">{ret.ImpuestoDR}</span></div>
                                    <span className="text-muted">|</span>
                                    <div><span className="text-muted">Importe:</span> <span className="fw-bold text-danger">${ret.ImporteDR}</span></div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

DocumentoRelacionado.propTypes = {
    documentos: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

export default DocumentoRelacionado;
